import type { Node } from '@xyflow/react';

export enum NodeEditModeEnum {
  EditExisting = 'edit-existing',
  EditDraft = 'edit-draft',
  Library = 'library',
}

export type EditNodeFormProps = {
  mode: NodeEditModeEnum.EditDraft | NodeEditModeEnum.EditExisting;
  node: Node;
  onSave: (data: Record<string, unknown>) => void;
  onClose: () => void;
};
